



























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AnalyseOutAirtimedata from "./analyse-outairtimedata.vue";
import * as XLSX from "xlsx";
//import Echarts from "./Echarts.vue";

class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  etype:Number;
  // wId:Number;
  //fId:Number;
  cId: Number;
  EndTime: Date=new Date();
  mac: string;
  Time: string;
  displayId:number;
}
class PageCompanyRequest {
  cId: Number;
  ftId:Number;
  wId:Number;
}
@Component({
  components: { AnalyseOutAirtimedata },
})
export default class ThRealTimeDatas extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  analyseModalShow: boolean = false;
  userName: string;
  cId: Number;
  list1;
  mac:string='';
  wflocation:string='';
  selDateTime:Date=new Date();
  datalist1 = [];
  temp:string = '';
  humi = [];
  eid:string='';
  selwarehouselist = [];
  selfloorlist = [];

  get list() {
    return this.$store.state.outair_equipment.list;
  }
  get loading() {
    return this.$store.state.outair_equipment.loading;
  }
  selCompany(value: Number) {
    this.$store.state.outair_equipment.pageSize=10;
    this.$store.state.outair_equipment.currentPage=1;
    this.$store.state.outair_equipment.totalCount=0;
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
    this.getfloor();
    this.getPage();
  }
  //库区
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    // this.getwarehouse();
    //   this.getfloor();
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
    this.$store.state.outair_equipment.currentPage=1;
       this.getPage();
  }
  //库房
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
      // this.getfloor();
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
    this.$store.state.outair_equipment.currentPage=1;
       this.getPage();
  }
  //楼层
  selfloor(value:Number){
  this.$store.state.outair_equipment.currentPage=1;
    this.getPage();
  }
  pageChange(page: number) {
    this.$store.commit("outair_equipment/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("outair_equipment/setPageSize", pagesize);
    this.getPage();
  }
  getsearch(){
    this.$store.state.outair_equipment.currentPage=1;
    this.getPage();
  }
  async getPage() {
     this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.etype = 0;
    //filters
    await this.$store.dispatch({
      type: "outair_equipment/GetRealPaged",
      data: this.pagerequest,
    });
  }

 
  get pageSize() {
    return this.$store.state.outair_equipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.outair_equipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.outair_equipment.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get outair_equipment() {
    return this.$store.state.outair_equipment.list;
  }
  outair_equipmentlist() {
    return this.$store.state.outair_equipment.list;
  }
  analyse() {
    this.selDateTime=this.pagerequest.EndTime;
    this.analyseModalShow = true;
  }
  setNames(paramftid,paramwid,paramfid,paramlocation){
    let ftid = paramftid;
    let wid = paramwid;
    let fid = paramfid;
    let ftlist = this.factorylist(); 
    for (let entry of ftlist) {
      if(ftid==entry.id){
        ftid=entry.fName + "室外";
        break;
      }
    }
    let wlist = this.warehouselist(); 
    for(let entry of wlist) {
      if(wid==entry.id){
        wid= "（" +entry.wName + "东侧）";
        break;
      }
    }
    // let flist = this.floorlist();
    // for(let entry of flist){
    //   if(fid == entry.id){
    //     fid = entry.fName;
    //     break;
    //   }
    // }
    this.wflocation =ftid + wid;
    // if(ftid == 0){
    //   this.wflocation =wid + fid + paramlocation;
    // }
    // if(paramlocation == null){
    //   this.wflocation = ftid + wid + fid;
    // }

  }

  columns = [
    {
      title: "所属公司",
      key: "cId",
      width:180,
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
     {
      title: "库区",
      key: "ftId",
      width:200,
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    }, 
    // {
    //   title: "库房",
    //   key: "wName",
    //   render: (h, params) => {
    //     let wId = params.row.wId;
    //     let wlist = this.warehouselist();
    //     for (let entry of wlist) {
    //       //console.log(entry.id); // 1, "string", false
    //       if (wId == entry.id) {
    //         wId = entry.wName;
    //         break;
    //       }
    //     }
    //     return h("span", wId);
    //   },
    // },
    // {
    //   title: "楼层",
    //   key: "fName",
    //   render: (h, params) => {
    //     let fId = params.row.fId;
    //     let flist = this.floorlist();
    //     for (let entry of flist) {
    //       //console.log(entry.id); // 1, "string", false
    //       if (fId == entry.id) {
    //         fId = entry.fName;
    //         break;
    //       }
    //     }
    //     return h("span", fId);
    //   },
    // },
    {
      title: "SN号",
      key: "snid",
      width:200,
    },
    // {
    //   title: "垛位号",
    //   key: "locationName",
    // },
    // {
    //   title: "剩余电量",
    //  width:110,
    //   key: "electric",
    //   render: (h, params) => {
    //    let Electric = params.row.electric;
    //      let username = this.getuserName();
    //     if(username !== "admin"){
    //       if(Electric > 30){
    //         Electric = "电量充足";
    //       }
    //       else if(Electric > 11 && Electric < 31){
    //          Electric = "电量一般";
    //       }
    //       else{
    //          Electric = "电量不足";
    //       }
    //     }
    //     else{
    //       Electric= Electric.toString() + "%";
    //     }
    //     return h("span",Electric);
    //   },
    // },
    // {
    //   title: "信号强度",
    //  width:110,
    //   key: "signale",
    //   render: (h, params) => {
    //     return h("span", params.row.signale+'%');
    //   },
    // },
    {
      title: "温度",
     width:110,
      key: "temp",
       render: (h, params) => {
           var temp = params.row.temp + "℃";         
        return h("span",{style:"white-space: pre-wrap"}, temp);
      },
    },
    {
      title: "湿度",
     width:110,
      key: "humi",
       render: (h, params) => {
        var humi = params.row.humi + "%";
        return h("span",{style:"white-space:pre-wrap"}, humi);
      },
    },
    {
      title: "PM2.5",
      key: "pM25",
      width:110,
      render: (h, params) => {
           if(params.row.pM25==null){
             return h("span", '0');
        }
        return h("span", params.row.pM25+'ug/m³');
      },
    },
    {
      title: "PM10",
      key: "pM10",
      width:110,
      render: (h, params) => {
           if(params.row.pM10==null){
             return h("span", '0');
        }
        return h("span", params.row.pM10+'ug/m³');
      },
    },
    {
      title: "VOC",
      key: "voc",
       width:120,
       render: (h, params) => {
           if(params.row.voc==null){
             return h("span", '0');
        }
        return h("span", params.row.voc+'mg/m3');
      },
    },
    {
      title: "风速",
      key: "wind_speed",
      width:110,
       render: (h, params) => {
           if(params.row.wind_speed==null){
             return h("span", '0');
        }
        return h("span", params.row.wind_speed+'m/s');
      },
    },
    {
      title: "风向",
      key: "wind_direction",
      width:110,
       render:(h,params) =>{
        let winds = params.row.wind_direction;
        if(winds == 0){
          winds="北风";
        }else if(winds == 1){
          winds="东北风";
        }else if(winds == 2){
          winds="东风";
        }else if(winds == 3){
          winds="东南风";
        }else if(winds == 4){
          winds="南风";
        }else if(winds == 5){
          winds="西南风";
        }else if(winds == 6){
          winds="西风";
        }else if(winds == 7){
          winds="西北风";
        }
        return h("span",winds)
      }
    },
    {
      title: "噪音",
      key: "noise",
      width:110,
       render: (h, params) => {
           if(params.row.noise==null){
             return h("span", '0');
        }
        return h("span", params.row.noise+'dB');
      },
    },
    {
      title: "大气压",
      key: "pressure", 
      width:110,
      render: (h, params) => {
           if(params.row.pressure==null){
             return h("span", '0');
        }
        return h("span", params.row.pressure+'kPa');
      },
    },
    {
      title: "更新时间",
      width:150,
      key: "endtime",
      render: (h, params) => {
        let endTime ='';
        
        endTime=this.GetDay(params.row.endtime)+' '+this.GetMinutes(params.row.endtime);
        return h("span", endTime);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 110,
      fixed:"right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "2px",
              },
              on: {
                click: () => {
                 let strtime = params.row.endtime;
                 let datetime1 = new Date(params.row.endtime);
                  if(strtime.toString() == '0001-01-01T00:00:00'){
                    datetime1 = new Date();
                 }
                 this.pagerequest.EndTime = datetime1;
                 this.setNames(params.row.ftId,params.row.wId,params.row.fId,params.row.locationName);
                  this.$store.commit("outair_equipment/analyse", params.row);
                  this.analyse();
                },
              },
            },
            "数据分析"
          ),
         
        ]);
      },
    },
  ];

  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }

  GetDay(time) {
    let date = new Date(time);
    let Str = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
    }
    async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  created() {
     this.$store.state.outair_equipment.pageSize=10;
    this.$store.state.outair_equipment.currentPage=1;
    this.$store.state.outair_equipment.totalCount=0;
    this.getuserName();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }
    this.getwarehouse();
    this.getfloor();
    this.getfactory();

    this.getPage();
  }
}
